import Datepicker from "vuejs-datepicker"
import {nl} from 'vuejs-datepicker/dist/locale'
import * as SPINNER from '../helpers/spinner'

if ($('#checkout').length) {
    const checkout = new Vue({
        el: '#checkout',
        components: {
            Datepicker,
        },
        data: {
            cart: null,
            shipping_methods: null,
            nl: nl,
            disabled_dates: {
                days: [],
                dates: [],
                ranges: [],
            },
            create_account: null,
            page_done: false,
            business_client: null,
            zipcode_check_countrys: ['NL'],
            steps: null,
            current_step: null,
            ideal_method_id: null,
            klarna_countries: null,
            show_address_error: false,
        },
        created: function () {
            this.removeHeaderAndFooter();
            this.getCartContent();
        },
        watch: {
            cart: function () {
                if (!this.shipping_methods) {
                    this.addressCheck();
                }
            },
            page_done: function () {
                if (this.page_done) {
                    if (window.ApplePaySession && ApplePaySession.supportsVersion(3) && ApplePaySession.canMakePayments()) {
                        $('#apple-pay-checkbox').show();
                    }      

                    try {
                        var cookie = {};
                        document.cookie.split(';').forEach(function(el) {
                            var splitCookie = el.split('=');
                            var key = splitCookie[0].trim();
                            var value = splitCookie[1];
                            cookie[key] = value;
                        });
                        
                        $('input[name="client_id"]').val(cookie["_ga"].substring(6));
                    } catch (e) {
                        console.error('Error getting GA4 client ID:', e);
                    }
                }
            }
        },
        methods: {
            getCartContent: function (shipping_method, delivery_date) {
                shipping_method = typeof shipping_method !== 'undefined' ? shipping_method : null;
                delivery_date = typeof delivery_date !== 'undefined' ? delivery_date : null;

                SPINNER.showSpinner();
                let vm = this;
                axios.get('/ajax/cart/content').then(function (res) {
                    vm.cart = res.data

                    if (typeof disabled_days !== 'undefined' && typeof disabled_days === 'object') {
                        vm.setDisabledDays(disabled_days);
                    }

                    if (typeof create_account !== 'undefined' && create_account) {
                        vm.create_account = true;
                    }

                    vm.cart.user_address = (typeof user_address === 'undefined')
                        ? false
                        : user_address;

                    if (old_billing_address) {
                        vm.cart.billing_address = old_billing_address;
                    } else if (vm.cart.user_address) {
                        vm.cart.billing_address.country = vm.cart.user_address.country
                    }

                    if (old_shipping_address) {
                        vm.cart.shipping_address = old_shipping_address;
                    } else if (vm.cart.user_address) {
                        vm.cart.shipping_address.country = vm.cart.user_address.country
                    }

                    if (shipping_method !== null) {
                        vm.cart.shipping_method = shipping_method;
                        vm.cart.delivery_date = delivery_date;
                    }

                    if (vm.business_client == null) {
                        vm.business_client = business_client ?? 0;
                    }

                    if (vm.steps == null) {
                        vm.steps = steps;
                        vm.current_step = default_step;
                    }

                    if (vm.ideal_method_id == null) {
                        vm.ideal_method_id = ideal_method_id;
                    }

                    if (vm.klarna_countries == null) {
                        vm.klarna_countries = klarna_countries;
                    }

                    SPINNER.hideSpinner();
                })
                .catch(
                    function (error) {
                        if (
                            typeof error.response !== 'undefined'
                            && typeof error.response.status !== 'undefined'
                            && error.response.status === 419
                        ) {
                            window.refreshCsrfToken()
                                .then(() => {
                                        vm.getCartContent(shipping_method, delivery_date);
                                    }
                                );
                        }
                    }
                );
            },
            addressCheck() {
                let address = '';

                if (this.cart.user_address = user_address) {
                    if (this.cart.use_shipping_address) {
                        address = this.cart.shipping_address;
                    } else if (this.cart.use_different_address) {
                        address = this.cart.billing_address;
                    } else {
                        address = this.cart.user_address;
                    }
                } else {
                    if (this.cart.use_shipping_address) {
                        address = this.cart.shipping_address;
                    } else {
                        address = this.cart.billing_address;
                    }
                }

                if (!this.zipcode_check_countrys.includes(address.country)) {
                    address.zipcode_check = true;
                    address.zipcode_readonly = false;
                } else if (!address.street && !address.city) {
                    address.zipcode_check = false;
                } else {
                    address.zipcode_check = true;
                    address.zipcode_readonly = true;
                }

                this.delivery_address = address;

                this.$forceUpdate();
                this.updateShippingCountry(address);
                // this.getShippingMethods(address.country, address.zipcode);
            },
            companyCheck() {
                let bussiness_address = 0;

                if (this.business_client == 1) {
                    bussiness_address = 1;
                }

                if (this.cart.use_shipping_address) {
                    bussiness_address = this.cart.shipping_address.company ? 1 : 0;
                }

                return bussiness_address;
            },
            getShippingMethods: function (country = this.cart.shipping_country, zipcode = '0', update_method = false, delivery_type = 'home_address') {
                let has_same_day_delivery = 1;
                let is_pickup_only = this.cart.is_pickup_only ? 1 : 0;
                let company = this.companyCheck();

                axios.get('/ajax/shippingmethods/' + country + '/' + zipcode + '/' + has_same_day_delivery + '/' + company + '/' + is_pickup_only + '/' + delivery_type, {}).then(res => {
                    let vm = this;
                    this.shipping_methods = res.data;
                    $.each(this.shipping_methods, function (key, method) {

                        if (method.type == 'default' || method.type == 'default_wholesale') {
                            vm.cart.shipping_method = method;
                            vm.cart.delivery_date = method.delivery_date;
                        }
                    })
                    if (update_method) {
                        this.updateShippingMethod(vm.cart.shipping_method);
                    }

                    if (!this.page_done) {
                        this.page_done = true;
                    }
                    vm.setDisabledDays(disabled_days);
                }).catch(
                    function (error) {
                        if (
                            typeof error.response !== 'undefined'
                            && typeof error.response.status !== 'undefined'
                            && error.response.status === 419
                        ) {
                            window.refreshCsrfToken()
                                .then(() => {
                                        vm.getShippingMethods(
                                            country,
                                            zipcode,
                                            update_method,
                                            delivery_type
                                        );
                                    }
                                );
                        }
                    }
                );
            },
            zipcodeCheck: function (address) {
                if (address.country === "NL") {
                    if (address.zipcode.length >= 6 && address.house_number != null) {
                        SPINNER.showSpinner();
                        this.getAddress(address, address.zipcode, address.house_number ?? null, address.country);
                        this.getShippingMethods(address.country, address.zipcode);
                        SPINNER.hideSpinner();
                    }
                }
                    // else if(address.country === "BE") {
                    //     if (address.zipcode.length >= 4) {
                    //         this.getAddress(address, address.zipcode, address.house_number ?? null, address.country);
                    //     }
                // }
                else {
                    address.zipcode_check = true;
                }
            },
            getAddress: function (address, zipcode, houseNumber, country) {
                let vm = this;
                this.show_address_error = false;
                axios.post('/ajax/zipcode', {
                    zipcode,
                    houseNumber,
                    country
                }).then(res => {
                    const data = res.data;

                    if (data.street && data.city) {
                        address.street_name = data.street;
                        address.city = data.city;
                        address.zipcode_readonly = true;
                        vm.show_address_error = false;
                    } else {
                        vm.show_address_error = true;
                        address.street_name = '';
                        address.city = '';
                        address.zipcode_readonly = false;
                    }

                    address.zipcode_check = true;
                    this.$forceUpdate();
                })
                .catch(function (error) {
                    if (error.response.status === 419) {
                        window.refreshCsrfToken()
                            .then(() => {
                                    vm.getAddress(address, zipcode, houseNumber, country);
                                }
                            );
                    } else {
                        vm.show_address_error = true;
                        address.street_name = '';
                        address.city = '';
                        address.zipcode_readonly = false;
                        address.zipcode_check = false;
                        vm.$forceUpdate();
                    }
                });
            },
            changeAddress: function (address) {
                address.zipcode_readonly = false;
                this.$forceUpdate();
            },
            updateShippingMethod: function (method) {
                const vm = this;
                axios.post('/ajax/cart/shippingmethod', {
                    shippingMethodId: method.id,
                }).then(function (res) {
                    const data = res.data;
                    $.each(data, function (key, value) {
                        vm.cart[key] = value;
                    });

                    vm.cart.delivery_date = method.delivery_date;
                    vm.disabled_dates.days = method.disabled_days;
                    vm.disabled_dates.to = new Date(vm.cart.delivery_date);

                    if ($('.vdp-datepicker__calendar header .next')[0]) {
                        $('.vdp-datepicker__calendar header .next')[0].click();
                        $('.vdp-datepicker__calendar header .prev')[0].click();
                    }
                }).catch(
                    function (error) {
                        if (
                            typeof error.response !== 'undefined'
                            && typeof error.response.status !== 'undefined'
                            && error.response.status === 419
                        ) {
                            window.refreshCsrfToken()
                                .then(() => {
                                        vm.updateShippingMethod(method);
                                    }
                                );
                        }
                    }
                );
            },
            changePickupLocation: function (location) {
                const vm = this;
                axios.post('/ajax/cart/pickuplocation', {
                    pickupLocationId: location.id,
                }).then(function (res) {
                    vm.cart.selected_pickup_location = location;
                }).catch(
                    function (error) {
                        if (
                            typeof error.response !== 'undefined'
                            && typeof error.response.status !== 'undefined'
                            && error.response.status === 419
                        ) {
                            window.refreshCsrfToken()
                                .then(() => {
                                        vm.changePickupLocation(location);
                                    }
                                );
                        }
                    }
                );
            },
            // updateShippingMethod: function (id) {
            //     axios.post('/ajax/cart/shippingmethod', {
            //         shippingMethodId: id,
            //     }).then(() => this.getCartContent())
            // },
            updateShippingCountry: function (address) {
                let vm = this;
                axios.post('/ajax/cart/shippingcountry', {
                    shippingMethodCountry: address.country,
                }).then(function () {
                    vm.cart.shipping_country = address.country;
                    vm.getShippingMethods(address.country, address.zipcode, true)
                }).catch(
                    function (error) {
                        if (
                            typeof error.response !== 'undefined'
                            && typeof error.response.status !== 'undefined'
                            && error.response.status === 419
                        ) {
                            window.refreshCsrfToken()
                                .then(() => {
                                        vm.updateShippingCountry(address);
                                    }
                                );
                        }
                    }
                );
            },
            // updateShippingCountry: function (country) {
            //     axios.post('/ajax/cart/shippingcountry', {
            //         shippingMethodCountry: country,
            //     }).then()
            // },
            addCoupon: function () {
                const vm = this;
                const shipping_method = vm.cart.shipping_method;
                const delivery_date = vm.cart.delivery_date;
                let codeInput = $('.coupon_code:visible').removeClass('is-invalid')
                let codeError = $('.coupon_code_error:visible').text('')
                const coupon_code = codeInput.val()

                axios.post('/ajax/cart/coupon/add', {
                    coupon_code,
                })
                    .then(function () {
                        vm.getCartContent(shipping_method, delivery_date);
                    })
                    .catch(err => {
                        codeInput.addClass('is-invalid')
                        codeError.text(err.response.data)
                    })
            },
            removeCoupon: function (id) {
                const vm = this;
                const shipping_method = vm.cart.shipping_method;
                const delivery_date = vm.cart.delivery_date;
                axios.delete(`/ajax/cart/coupon/${id}/delete`)
                    .then(function () {
                        vm.getCartContent(shipping_method, delivery_date);
                    });
            },
            currency: function (value) {
                return '€ ' + parseFloat(value).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            },
            country: function (value) {
                return this.cart.country_array[value];
            },
            toggleCreateAccount: function () {
                this.create_account = !this.create_account;
            },
            deliveryDateChanged: function () {
                if (typeof this.cart.delivery_date == 'object') {
                    this.cart.delivery_date = this.cart.delivery_date.toUTCString();
                }
            },
            setDisabledDays: function (disabled_days) {
                let vm = this;
                vm.disabled_dates.dates = [];
                $.each(disabled_days[vm.cart.shipping_country], function (key, day) {
                    vm.disabled_dates.dates.push(new Date(day));
                })
            },
            formSubmit: function (event) {
                event.target.disabled = true;
                event.target.form.submit();
                SPINNER.showSpinner();
            },
            nextStep: function () {
                let index = this.steps.indexOf(this.current_step);
                if (this.steps[index] == 'data') {
                    this.validateStep(index)
                } else {
                    this.current_step = this.steps[index + 1];
                    window.scrollTo({top: 0, behavior: 'smooth'});
                }
            },
            previousStep: function () {
                let index = this.steps.indexOf(this.current_step);
                this.current_step = this.steps[index - 1];

                window.scrollTo({top: 0, behavior: 'smooth'});
            },
            removeHeaderAndFooter: function () {
                $('.mega-menu').hide();
                $('.usp').hide();
                $('.footer-menu').hide();
                $('nav-toggler').hide();

                $('.product-detail').css('padding-top', $('header').height() + 20)
                $('.footer-copyright').css('background-color', 'white');
                // $('body').css('min-height', '100vh');
                // $('.site-container').css('padding-bottom', $('footer').height());
                // $('footer').css({
                //     'position': 'fixed',
                //     'bottom' : '0',
                //     'width': '100%'
                // });
            },
            login: function () {
                let login_errors = $('.login-errors');
                axios.post('/auth/login', $('.login-section :input').serialize())
                    .then(res => {
                        if (res.data.success) {
                            location.reload()
                        } else {
                            let errors = Array();
                            $.each(res.data.errors, function () {
                                $.each(this, function () {
                                    errors.push(this);
                                });
                            });

                            if (errors.length) {
                                login_errors.html(errors.join('<br />'));
                                login_errors.removeClass('d-none');
                            }
                        }
                    });
            },
            validateStep: function (index) {
                let vm = this;
                vm.removeErrors();
                SPINNER.showSpinner();

                axios.post('/order/validate/checkout', $('.step :input').serialize())
                    .then(res => {
                        SPINNER.hideSpinner();
                        this.current_step = this.steps[index + 1];
                        window.scrollTo({top: 0, behavior: 'smooth'});
                    })
                    .catch(
                        function (res) {
                            if (res.response.status === 419) {
                                window.refreshCsrfToken()
                                    .then(() => {
                                        vm.validateStep(index);
                                    })
                                    .catch(function () {
                                        vm.showErrors(res.response.data.errors);
                                        SPINNER.hideSpinner();
                                    }
                                );
                            } else if (res.response.status === 422) {
                                vm.showErrors(res.response.data.errors);
                                SPINNER.hideSpinner();
                            } else {
                                if (
                                    typeof res.data !== 'undefined'
                                    && typeof res.data.errors !== 'undefined'
                                ) {
                                    vm.showErrors(res.data.errors);
                                }
                                SPINNER.hideSpinner();
                            }
                        }
                    );
            },
            klarnaCheck: function () {
                if (this.cart.user_address = user_address) {
                    if (this.cart.use_different_address) {
                        return klarna_countries.includes(this.cart.billing_address.country)
                    } else {
                        return klarna_countries.includes(this.cart.user_address.country)
                    }
                } else {
                    return klarna_countries.includes(this.cart.billing_address.country)
                }
            },
            showErrors: function (errors, form, prefix) {
                if (errors === undefined || errors === null) {
                    // console.log('showErrors: Errors are not defined');
                    return;
                }

                for (let [key, message] of Object.entries(errors)) {
                    key = key.replace('.', '-');
                    const error_html = "<div class='text-danger field-error small'>" + message + "</div>"
                    $('#' + key).after(error_html);
                }
            },
            removeErrors: function () {
                $('.field-error').remove();
            }
        }
    })
}
